import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const submitEventForm = (payload) =>
  connectApi({ method: "POST", url: baseURL.submitEventForm, payload });

export const checkDuplcateSubmission = ({
  email,
  phone,
  workshop_detail_id,
  lang,
}) =>
  connectApi({
    method: "GET",
    url: `${baseURL.checkDuplcateSubmission}?workshop_detail_id=${workshop_detail_id}&email=${email}&phone=${phone}`,
  });

export const getWorkShopList = ({ code, workshop_code }) => {
  const params = new URLSearchParams();

  if (code) params.append("code", code);
  if (workshop_code) params.append("workshop_code", workshop_code);

  const queryString = params.toString();
  const url = queryString
    ? `${baseURL.getWorkShopList}?${queryString}`
    : baseURL.getWorkShopList;

  return connectApi({
    method: "GET",
    url,
  });
};
